import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CommonBindingDataService } from '../../../services/common-binding-data.service';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';

@Component({
  selector: 'app-mi-textarea',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, InputTextareaModule, TranslateModule],
  templateUrl: './mi-textarea.component.html',
  styleUrl: './mi-textarea.component.scss'
})
export class MiTextareaComponent implements OnInit, OnDestroy {
  @Input() field: any;
  @Input() attributeLabels: [];
  @Input() moduleName: string;
  formName: FormGroup;
  placeholder: any;
  maxLength = 500;
  controlName: any;
  showReturnReason = false;
  private returnReasonSubscription: Subscription;

  constructor(private formGroupDirective: FormGroupDirective,
    public cs: CommonBindingDataService,
    private metaDataService: MetaDataService) {
    this.formName = this.formGroupDirective.control;
  }

  ngOnInit() {
    this.controlName = this.field?.isOneToMultiple ? this.field?.attributeCodeOneToMultiple : this.field.attributeCode;
    this.placeholder = this.cs.getLabelValue(`${this.moduleName}.fields.${this.field.attributeCode}.placeholder`, this.attributeLabels, null);
    this.placeholder = this.placeholder === null ? '' : this.placeholder;
    if (this.field.attributeCode === 'return_reason') {
      this.returnReasonSubscription = this.metaDataService.returnReasonVisibility$.subscribe(
        (shouldShow: boolean) => {
          if(shouldShow) {
            this.formName.get(this.controlName).setValidators([Validators.required]);
            this.field.validation.required = true;
            this.formName.get(this.controlName).enable();
          } else {
            this.formName.get(this.controlName).reset();
            this.field.validation.required = false;
            this.formName.get(this.controlName).disable();
            this.formName.get(this.controlName).clearValidators();
          }
          this.formName.get(this.controlName).updateValueAndValidity();
        }
      );
    }
  }

  ngOnDestroy() {
    if (this.returnReasonSubscription) {
      this.returnReasonSubscription.unsubscribe();
    }
  }
}
